import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';

// Pick the largest available scale from image_scales as the lightbox source.
// image_scales shape: { <field>: [ { scale: 'large', href, width, height }, ... ] }
// Falls back to `${appUrl}/@@images/<field>/huge` then the raw url.
//
// Moved verbatim from volto-vilax/src/components/Blocks/ImageGallery/Lightbox.jsx
// during DR-2026-126 extraction.
export const resolveFullsizeSrc = (img) => {
  if (!img) return null;
  if (img.image_scales && img.image_field) {
    const scales = img.image_scales[img.image_field];
    if (Array.isArray(scales) && scales.length > 0) {
      const largest = [...scales].sort(
        (a, b) => (b.width || 0) - (a.width || 0),
      )[0];
      if (largest?.download) {
        return isInternalURL(largest.download)
          ? flattenToAppURL(largest.download)
          : largest.download;
      }
    }
    return `${flattenToAppURL(img.url)}/@@images/${img.image_field}/huge`;
  }
  if (img.url) {
    return isInternalURL(img.url)
      ? `${flattenToAppURL(img.url)}/@@images/image/huge`
      : img.url;
  }
  return null;
};
